import { arraysEqual } from "../array/arraysEquals.js";
function objectsEqual(o1, o2) {
  if (o1 === o2) {
    return true;
  }
  if (o1 === null || o2 === null || typeof o1 !== "object" || typeof o2 !== "object") {
    return false;
  }
  if (Array.isArray(o1) && Array.isArray(o2)) {
    return arraysEqual(o1, o2);
  }
  if (Object.prototype.toString.call(o1) !== Object.prototype.toString.call(o2)) {
    return false;
  }
  const keys1 = Object.keys(o1);
  const keys2 = Object.keys(o2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  return keys1.every((key) => objectsEqual(o1[key], o2[key]));
}
export {
  objectsEqual
};
